import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const InputRow = styled.div<{ compact?: boolean }>`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: space-between;

  ${(props) =>
    props.compact
      ? `
    flex-direction: column;
  `
      : `
    & > div:first-child {
      margin-right: 30px;
    }
  `}

  & > div {
    flex: 1;
    margin-top: 20px;
  }

  @media (${mobileXXLargeMax}) {
    flex-direction: column;

    & > div:first-child {
      margin-right: 0px;
    }
  }
`;

export default InputRow;
